export const buildingIconURL = `${process.env.REACT_APP_STORAGE_BASE_URL}/icons/building.svg`;
